<template>
  <div class="animated fadeIn">
    <Tabs type="card" @on-click="onTabClick">
      <TabPane label="自定义个人统计">
        <custom-person-report ref="customPersonReport"></custom-person-report>
      </TabPane>
      <TabPane label="月度个人统计">
        <month-person-report ref="monthPersonReport"></month-person-report>
      </TabPane>
      <TabPane label="季度个人统计">
        <quarter-person-report ref="quarterPersonReport"></quarter-person-report>
      </TabPane>
      <TabPane label="年度个人统计">
        <year-person-report ref="yearPersonReport"></year-person-report>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>

import CustomPersonReport from '@/view/br/components/custom-person-report'
import MonthPersonReport from '@/view/br/components/month-person-report'
import QuarterPersonReport from '@/view/br/components/quarter-person-report'
import YearPersonReport from '@/view/br/components/year-person-report'

export default {
  name: 'personalbrreport',
  components: {
    CustomPersonReport,
    MonthPersonReport,
    QuarterPersonReport,
    YearPersonReport
  },
  data () {
    return {

    }
  },
  methods: {
    onTabClick (name) {
      switch (name) {
        case 0:
          this.$refs.customPersonReport.onShow()
          break
        case 1:
          this.$refs.monthPersonReport.onShow()
          break
        case 2:
          this.$refs.quarterPersonReport.onShow()
          break
        case 3:
          this.$refs.yearPersonReport.onShow()
          break
      }
    }
  },
  mounted () {
    const token = this.$store.getters.token
  }
}
</script>

<style type="text/css" scoped>
</style>
